import React, { useEffect, useState } from 'react'
import ProcDashTopSection from './dashboardComponents/ProcDashTopSection';
import ProcDashBottomSection from './ProcDashBottomSection';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import GenericFormComponent from '../../../genericComponents/forms/GenericFormComponent';
import Icons from '../../../assets/icons';
import { Radio } from 'antd';
import QuickFilter from '../components/QuickFilter';
import dayjs from 'dayjs';
import { getCurrentDateFormat, getDataStorageKey } from '../../../helper/helperTableFunctions';
import { openDB } from 'idb';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import moment from 'moment';
import { parseJwt } from '../../../helper/genericFunction';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { HistoryIcon } from 'lucide-react';

const FILTERS = [
    {
        value: "Site",
        key: "name1",
        code: "code",
        entity: "site",
        headerKeys: {
            'name1': { value: 'Site' },
            'code': { value: 'Code' }
        },
        itemKeys: {
            'name1': ['name1'],
            'code': ['code']
        },
    },
    {
        value: "Vendor",
        key: "slname",
        code: "slcode",
        entity: "vendor",
        headerKeys: {
            'slname': { value: 'Vendor' },
            'slcode': { value: 'Code' }
        },
        itemKeys: {
            'slname': ['slname'],
            'slcode': ['slcode']
        }
    }
]

const PRIMARY_FILTERS = [
    {
        value: "Division",
        key: "hl1_name",
        code: "hl1_code",
        entity: "item",
    },
    {
        value: "Section",
        key: "hl2_name",
        code: "hl2_code",
        entity: "item",
    },
    {
        value: "Department",
        key: "hl3_name",
        code: "hl3_code",
        entity: "item",
    },
    {
        value: "Article Name",
        key: "hl4_name",
        code: "hl4_code",
        entity: "item",
    }
]

function ProcDashboard(props) {
    const digiProcStore = useSelector(state => state?.digiProcStore);
    const { getPiSummaryData, getPiCountPerData, getPoCountPerData } = digiProcStore;


    const [inputData, setInputData] = useState({});
    const [errorData, setErrorData] = useState({});
    const [filters, setFilters] = useState({ setType: undefined });
    const [disabledApplyFilterBtn, setDisabledApplyFilterBtn] = useState(true);
    const [masterDbResponse, setMasterDbResponse] = useState({});
    const [mviewData, setMviewData] = useState({});

    const dispatch = useDispatch()

    useEffect(() => {
        if (Object.keys(inputData || {}).length !== 0) {
            setDisabledApplyFilterBtn(false)
        }
    }, [inputData]);

    useEffect(() => {
        updateMasterDbResponse()
    }, []);

    // Function: To update the master db response
    const updateMasterDbResponse = async () => {
        const db = await openDB(getDataStorageKey?.(), 1);
        let updatedMasterDbResponse = {};
        ["DYNAMIC_ITEM_CONFIG", "DYNAMIC_SITE_CONFIG"]?.map(async key => {
            let response = await db.get("MASTER_DB_DROPDOWN", key) || [];
            updatedMasterDbResponse[key] = response;
        })
        setMasterDbResponse(updatedMasterDbResponse)
        db?.close();
    }

    const handleApplyFilter = (state = inputData) => {
        let payload = {
            ...filters,
            creationTime: {
                from: state?.dateRange?.[0]?.format('YYYY-MM-DD') || '',
                to: state?.dateRange?.[1]?.format('YYYY-MM-DD') || '',
            },
            siteCode: state?.name1?.code || '',
            slCode: state?.slname?.slcode || '',
            hl1Code: state?.hl1_name?.hl1_code || "",
            hl2Code: state?.hl2_name?.hl2_code || "",
            hl3Code: state?.hl3_name?.hl3_code || "",
            hl4Code: state?.hl4_name?.hl4_code || "",
        }
        Object.keys(payload || {})?.map((key) => {
            if (key == "creationTime" && (payload?.[key]?.from == "" || payload?.[key]?.to == "")) {
                delete payload[key]
            }
            else if (payload?.[key] == "") {
                delete payload[key]
            }
        })
        setFilters(payload);
        setDisabledApplyFilterBtn(true);
    }

    const provideInputs = () => {
        let inputFieldsData = [{ key: "dateRange", type: "range", placeholder: ['Start Date', 'End Date'] }]
        inputFieldsData.push(...FILTERS.map((config) => {
            return {
                key: config?.key,
                iconRight: <Icons.DownArrowFilled />,
                modalMainClass: "use-as-generic-dropdown",
                placeholder: `${config?.value}`,
                type: 'dropdown',
                value: inputData?.[config?.key],
                inputProps: () => ({
                    search: {
                        placeholder: `Search ${config?.value}`,
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": config?.entity,
                                "key": config.key,
                                "code": config?.code,
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        switch (config.key) {
                            default: return response?.resource?.searchResultNew?.map(data => ({ [config.key]: data[config.key], ...data }))
                        }
                    },
                    headerKeys: config.headerKeys ?? {
                        [config.key]: { value: [config.value] },
                    },
                    itemKeys: config.itemKeys ?? {
                        [config.key]: [config.key],
                    }
                }),
            }
        }))

        inputFieldsData.push(...PRIMARY_FILTERS.map((config) => {
            return {
                key: config?.key,
                iconRight: <Icons.DownArrowFilled />,
                viewDataType: "table-view",
                modalMainClass: "use-as-generic-dropdown",
                placeholder: `Select ${config?.value}`,
                type: 'dropdown',
                value: inputData?.[config?.key],
                // onChange: (data) => handleChange(config?.key, data),
                inputProps: () => ({
                    viewDataType: "table-view",
                    search: {
                        placeholder: `Search ${config?.value}`,
                    },
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": config?.entity,
                                "key": config.key,
                                "code": config?.code,
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": getOtherData(config, inputData),
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        switch (config.uniqueKey) {
                            default: return response?.resource?.searchResultNew?.map(data => ({ [config.key]: data[config.key], ...data }))
                        }
                    },
                    headerKeys: {
                        [config.key]: { value: [config.value] },
                    },
                    itemKeys: {
                        [config.key]: [config.key],
                    }
                }),
            }
        }))
        return inputFieldsData
    }

    const handleClearFilters = () => {
        setInputData({})
        handleApplyFilter({ setType: undefined })
    }

    const getOtherData = (filter, filterData = {}) => {
        let otherData = {};
        const DROPDOWN_TYPE = "DYNAMIC_ITEM_CONFIG";
        if (DROPDOWN_TYPE) {
            let response = masterDbResponse?.[DROPDOWN_TYPE] || [];
            Object.keys(filterData || {})?.map(key => {
                if (Object.keys(filterData?.[key] || {})?.length > 0) {
                    Object.keys(filterData?.[key] || {})?.map(innerKey => {
                        if (key != filter?.key && filter?.["entity"]) {
                            if (response?.includes(key)) {
                                if (Object.keys(filterData?.[key] || {})?.length > 0) {
                                    otherData[key] = [filterData?.[key]?.[key]];
                                }
                            }
                        }
                    })
                }

            })
        }
        return otherData;
    }

    // Function to render the primary filters data
    const renderPrimaryFilters = () => {
        return (
            <div className='proc-dashboard all-filter-dashboard procV2Styling p-lr-0'>
                <GenericFormComponent
                    rowInput={{
                        rowType: "singleRow",
                        availableInputs: provideInputs(),
                        inputState: { ...inputData },
                        inputStateChangeFunction: (data) => {
                            setInputData(data);
                        },
                        errorData: { ...errorData },
                        updateErrorData: (data) => {
                            setErrorData(data);
                        },
                        rowRightExtras: <React.Fragment>
                            <div className='gfbi-btns'>
                                <GenericCustomButton
                                    label='Apply Filter'
                                    type='primary'
                                    onClick={() => handleApplyFilter()}
                                    disabled={disabledApplyFilterBtn}

                                />
                                <GenericCustomButton
                                    label="Clear All"
                                    type="default"
                                    onClick={handleClearFilters}
                                    disabled={Object.keys(inputData || {}).length === 0}
                                />
                            </div>
                        </React.Fragment>,
                    }}
                    availableDocument={props.availableDocument || null}
                />
                <QuickFilter
                    applyFilter={applyFilter}
                    filterPayload={filterPayload}
                    getCurrentFilters={() => getCurrentFilters()}
                    filterItems={filterItems}
                />
            </div>
        )
    }

    const transformData = (input) => {
        const transformedDataClone = {};

        if (input.hl4Name || input.hl4Code) {
            transformedDataClone.hl4_name = {
                hl4_name: input.hl4Name || "",
                hl4_code: input.hl4Code || ""
            };
        }

        if (input.hl1Name || input.hl1Code) {
            transformedDataClone.hl1_name = {
                hl1_name: input.hl1Name || "",
                hl1_code: input.hl1Code || ""
            };
        }

        if (input.hl2Name || input.hl2Code) {
            transformedDataClone.hl2_name = {
                hl2_name: input.hl2Name || "",
                hl2_code: input.hl2Code || ""
            };
        }

        if (input.hl3Name || input.hl3Code) {
            transformedDataClone.hl3_name = {
                hl3_name: input.hl3Name || "",
                hl3_code: input.hl3Code || ""
            };
        }

        if (input.creationTime?.from || input.creationTime?.to) {
            transformedDataClone.dateRange = [
                input.creationTime?.from ? dayjs(input.creationTime.from, getCurrentDateFormat(input.creationTime.from)) : "",
                input.creationTime?.to ? dayjs(input.creationTime.to, getCurrentDateFormat(input.creationTime.to)) : ""
            ].filter(Boolean);
        }

        if (input.site || input.SiteCode) {
            transformedDataClone.name1 = {
                name1: input.site || "",
                code: input.SiteCode || ""
            };
        }

        if (input.slName || input.slCode) {
            transformedDataClone.slname = {
                slname: input.slName || "",
                slCode: input.slCode || "",
            };
        }
        return transformedDataClone;
    }

    const applyFilter = (filters) => {
        let data = transformData(filters);
        setInputData(data);
        handleApplyFilter(data);
    }

    const filterPayload = {
        attributeType: "PROCUREMENT_DASHBOARD_FILTER",
        displayName: "PROCUREMENT_DASHBOARD_FILTER",
        filterName: ""
    };

    const getKeys = {
        dateRange: "creationTime",
        division: "hl1Name",
        section: "hl2Name",
        department: "hl3Name",
        article: "hl4Name",
        site: "site",
        vendor: "slName",
        // setType: "setType"
    }

    const getCurrentFilters = () => {
        let filterData = {};
        Object.keys(inputData || {})?.forEach(key => {
            switch (key) {
                case "hl4_name": {
                    filterData["hl4Name"] = inputData?.[key]?.[key]
                    filterData["hl4Code"] = inputData?.[key]?.["hl4_code"]
                    break;
                }
                case "hl1_name": {
                    filterData["hl1Name"] = inputData?.[key]?.[key]
                    filterData["hl1Code"] = inputData?.[key]?.["hl1_code"]
                    break;
                }
                case "hl2_name": {
                    filterData["hl2Name"] = inputData?.[key]?.[key]
                    filterData["hl2Code"] = inputData?.[key]?.["hl2_code"]
                    break;
                }
                case "hl3_name": {
                    filterData["hl3Name"] = inputData?.[key]?.[key]
                    filterData["hl3Code"] = inputData?.[key]?.["hl3_code"]
                    break;
                }
                case "slname": {
                    filterData["slName"] = inputData?.[key]?.[key]
                    filterData["slCode"] = inputData?.[key]?.["slcode"]
                    break;
                }
                case "name1": {
                    filterData["site"] = inputData?.[key]?.[key]
                    filterData["SiteCode"] = inputData?.[key]?.["code"]
                    break;
                }
                case "dateRange": {
                    filterData["creationTime"] = {
                        from: inputData?.[key]?.[0] ? dayjs(inputData[key][0].$d)?.format('YYYY-MM-DD') || '' : "",
                        to: inputData?.[key]?.[1].$d ? dayjs(inputData[key][1].$d)?.format('YYYY-MM-DD') || '' : "",
                    }
                    break;
                }
            }
        });
        Object.keys(filterData || {})?.forEach(key => {
            if (!filterData?.[key]) {
                delete filterData[key]
            }
        });
        return filterData
    }

    const filterItems = {
        "Default Headers": {
            creationTime: "Date From - Date To",
            hl4Name: "Article Name",
            hl3Name: "Department",
            hl1Name: "Division",
            hl2Name: "Section",
            hl1Code: "Division Code",
            hl2Code: "Section Code",
            hl3Code: "Department Code",
            hl4Code: "Article Code",
            SiteCode: "Site",
            site: "Site",
            slName: "Vendor",
            slCode: "Vendor Code",
        },
        "columnType": {
            creationTime: "DATE",
            hl1Name: "SEARCH",
            hl2Name: "SEARCH",
            hl3Name: "SEARCH",
            hl4Name: "SEARCH",
            name1: "SEARCH",
            code: "SEARCH",
            slName: "SEARCH",
            slCode: "SEARCH",
            hl1Code: "SEARCH",
            hl2Code: "SEARCH",
            hl3Code: "SEARCH",
            hl4Code: "SEARCH",
            SiteCode: "SEARCH",
            site: "SEARCH",
        },
    }

    const uType = parseJwt(sessionStorage.getItem("token"))?.uType;


    const refreshapidata = () => {
        dispatchHandler(dispatch, "getRefreshReportRequest", {
            viewName: mviewData.mvName
        })
    }


    return (
        <div className='pl-[30px] pr-[15px] pb-[15px] pt-[16px] mt-[-16px] overflow-hidden'>
            {/* <div className='all-filter-dashboard'> */}
            {renderPrimaryFilters()}
            {/* </div> */}

            {/* render the refresh button here */}
            {mviewData?.mvName && <div className='mb-[10px] flex justify-end items-center gap-3'>
                {mviewData?.mvUpdateDate &&
                <div className='w-auto flex items-center gap-1.5'>
                    <HistoryIcon size={14} color='#67768E' className='shrink-0' />
                    <p className='mb-0 text-[11px] font-normal text-[#525676]'>Last Updated:</p>
                    <p className='mb-0 text-[11px] font-normal text-[#67768E]'>{moment(
                            mviewData?.mvUpdateDate || ""
                        ).format("DD MMM YYYY, h:mm:ss a")}</p>
                </div>
                }
                {
                    uType == "ENT" && mviewData?.mvName &&
                    <GenericCustomButton
                        type='primary'
                        sendEventAnalyticsToGoogle={true}
                        label="Refresh Data"
                        loading={getPiSummaryData?.isLoading}
                        onClick={refreshapidata}
                        className='min-w-[116px]'
                    />
                }
            </div>}

            <div className='space-y-5 text-[#0F172A] mt-1'>
                <ProcDashTopSection filters={filters} setFilters={setFilters} inputData={inputData} setMviewData={setMviewData} />
                <ProcDashBottomSection filters={filters} setFilters={setFilters} />
            </div>
        </div>
    )
}

export default ProcDashboard